function clearCache() {
  try {
    // Limpar cache do Vue
    // if ('caches' in window) {
    //   caches.keys().then((names) => {
    //     names.forEach((name) => caches.delete(name))
    //   })
    // }

    // Limpar cache do LocalStorage e SessionStorage
    localStorage.clear()
    sessionStorage.clear()

    // Atualizar a página para garantir que nada do cache seja reutilizado
    window.location.reload(true)
  } catch (e) {
    console.log(e.message)
  }
}

export default clearCache
